export default "__VITE_ASSET__58c15c9a__"